import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import WEditor from '@/components/WEditor';
import { mapActions } from 'vuex';
import { SaveData, UploadFile } from '@/api/Announcement';
export default {
  components: {
    WEditor: WEditor
  },
  data: function data() {
    // const ISSUE_DATEval = (rule, value, callback) => {
    //   if (!value) callback(new Error(this.$t('Announcement._17')))
    //   callback()
    // }
    return {
      uploadUrl: this.$store.getters.getVUE_APP_API + '/Notice/UploadFile',
      // 打印模板
      mainform: {
        ID: '',
        CREATETIME: '',
        CREATORID: '',
        //
        TYPE_ID: 1,
        // 发布方式
        ISSUE_DATE: '',
        // 发布日期
        THEME: '',
        // 公告主题
        CONTENT: '',
        // 公告内容
        ATTACHMENT_URL: '',
        // 附件地址
        ATTACHMENT_NAME: '',
        // 附件文件名
        FILE_CODE: '',
        // 文档编号
        IS_SHOW_INDEX: 1,
        // 是否在首页显示
        CODE: '',
        // 单据编号
        ORGANIZE_ID: 10
      },
      fileList: [],
      UploadParamVal: {},
      PageStatus: true,
      EdaddStus: 0,
      submitForm: {
        InsertRecords: [],
        // 新增的记录
        UpdateRecords: [] // 更新的记录

      },
      rules: {
        ISSUE_DATE: [{
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }],
        THEME: [{
          required: true,
          message: '请输入公告标题',
          trigger: 'blur'
        }],
        CONTENT: [{
          required: true,
          message: '请输入公告内容',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    // 监听编辑公告
    this.Bus.on('mstData', function (e) {
      console.log(e);
      _this.mainform = e;

      _this.$refs.textarea.editor.setHtml(_this.mainform.CONTENT);

      console.log(_this.mainform);
    }); // 监听点击新增公告

    this.Bus.on('onClickaddOrder', function () {
      _this.mainform = {
        ID: '',
        CREATETIME: '',
        CREATORID: '',
        //
        TYPE_ID: 1,
        // 发布方式
        ISSUE_DATE: '',
        // 发布日期
        THEME: '',
        // 公告主题
        CONTENT: '',
        // 公告内容
        ATTACHMENT_URL: '',
        // 附件地址
        ATTACHMENT_NAME: '',
        // 附件文件名
        FILE_CODE: '',
        // 文档编号
        IS_SHOW_INDEX: 1,
        // 是否在首页显示
        CODE: '',
        // 单据编号
        ORGANIZE_ID: 10
      };
      _this.mainform.CREATETIME = _this.getNowFormatDate;
      console.log(_this.mainform);

      _this.$refs.textarea.editor.setHtml(_this.mainform.CONTENT);
    }); // 监听新增送货单保存

    this.Bus.on('onSaveaddOrder', function (mainform) {
      _this.mainform = mainform;

      _this.saveOrderForAdd();
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions('Portal/Announcement', ['setOrderStatu'])), {}, {
    // ÷上传前
    handleUpload: function handleUpload(file) {
      var Maxsize = file.size / 1024 < 10240;
      console.log(file);

      if (!Maxsize) {
        this.$Message.warning({
          content: '文件' + file.name + '不能超过10M.',
          duration: 5
        });
        return false;
      }

      if (file.status === 'ready') {
        this.fileList.push(file);
      }

      this.UploadParamVal.file_name = file.name;
    },
    handleAvatarSuccess: function handleAvatarSuccess(file) {
      console.log(file);
      this.mainform.ATTACHMENT_NAME = file.Result.ATTACHMENT_NAME;
      this.mainform.ATTACHMENT_URL = file.Result.ATTACHMENT_URL;
      console.log('自动上传成', this.mainform);
    },
    handleRemove: function handleRemove(file) {
      console.log(file);
      this.fileList = this.fileList.filter(function (item) {
        return item.uid !== file.uid;
      });
      console.log(this.fileList);
    },
    handlePreview: function handlePreview(file) {
      console.log(file);
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u5F53\u524D\u9650\u5236\u53EA\u80FD\u4E0A\u4F20 1 \u4E2A\u9644\u4EF6\uFF0C\u672C\u6B21\u5DF2\u7ECF\u4E0A\u4F20\u4E86 ".concat(files.length, " \u4E2A\u9644\u4EF6\uFF0C\u65E0\u6CD5\u4E0A\u4F20\u66F4\u591A\u9644\u4EF6"));
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    handleSaveData: function handleSaveData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.mainform.CONTENT = _this2.$refs.textarea.editor.getHtml();

                _this2.$nextTick(function () {
                  _this2.$refs.upload.submit();
                }); // console.log(this.$refs.textarea.html)


                if (!(_this2.mainform.ISSUE_DATE === '')) {
                  _context.next = 5;
                  break;
                }

                _this2.$message.error('请选择公告日期');

                return _context.abrupt("return", false);

              case 5:
                if (!(_this2.mainform.THEME === '')) {
                  _context.next = 8;
                  break;
                }

                _this2.$message.error('请填写公告标题');

                return _context.abrupt("return", false);

              case 8:
                if (!(_this2.ToString(_this2.mainform.CONTENT) === '')) {
                  _context.next = 11;
                  break;
                }

                _this2.$message.error('请填写公告内容');

                return _context.abrupt("return", false);

              case 11:
                _this2.mainform.CONTENT = _this2.$refs.textarea.editor.getHtml();

                if (!_this2.mainform.ID || _this2.mainform.ID === '') {
                  _this2.mainform.ID = 0;
                }

                _context.next = 15;
                return SaveData(_this2.mainform);

              case 15:
                res = _context.sent;

                if (res.Result !== null) {
                  _this2.mainform = {
                    ID: '',
                    CREATETIME: '',
                    CREATORID: '',
                    //
                    TYPE_ID: 1,
                    // 发布方式
                    ISSUE_DATE: '',
                    // 发布日期
                    THEME: '',
                    // 公告主题
                    CONTENT: '',
                    // 公告内容
                    ATTACHMENT_URL: '',
                    // 附件地址
                    ATTACHMENT_NAME: '',
                    // 附件文件名
                    FILE_CODE: '',
                    // 文档编号
                    IS_SHOW_INDEX: 1,
                    // 是否在首页显示
                    CODE: '',
                    // 单据编号
                    ORGANIZE_ID: 10
                  };
                  _this2.fileList = [];

                  _this2.$refs.upload.clearFiles();

                  _this2.$message.success('保存成功');

                  setTimeout(function () {
                    _this2.$parent.setOrderStatu('listShow');
                  }, 800);
                }

                console.log(_this2.mainform);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    ToString: function ToString(value) {
      var tag = document.createElement('div');
      tag.innerHTML = value;
      var strCode = tag.innerText || tag.textContent;
      tag = null;
      return strCode;
    },
    // 获取当前日期函数
    getNowFormatDate: function getNowFormatDate() {
      var date = new Date();
      var seperator1 = '-';
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) month = '0' + month;
      if (strDate >= 0 && strDate <= 9) strDate = '0' + strDate;
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    }
  })
};